// Lifted from useSubQuestions; pure so basic-output can reuse without React/Jotai.

import * as R from 'remeda'

import { type Question } from '~/hooks/useSurveyQuery'

export const buildMatrixSubQuestions = (
  questions: Question[],
  question: Question | null | undefined,
): Question[] =>
  R.intersectionWith(
    questions,
    question?.mt_questions ?? [],
    ({ question_id }, questionId) => question_id === questionId,
  )
